import { render, staticRenderFns } from "./exportPaperBtn.vue?vue&type=template&id=01f659c0&scoped=true&"
import script from "./exportPaperBtn.vue?vue&type=script&lang=js&"
export * from "./exportPaperBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f659c0",
  null
  
)

export default component.exports